import { ReportPrinter } from "./ReportPrinter";

export function textWithLine(
  printer: ReportPrinter,
  text: string,
  x: number,
  y: number,
  options?: {
    end?: number | "page";
    align?: "left" | "right";
    space?: number;
    offset?: number;
  }
) {
  const end =
    !options?.end || options.end === "page"
      ? printer.printableWidth
      : options.end;
  const space = !!options?.space || options?.space === 0 ? options.space : 5;
  const offset = options?.offset || 0;
  const align = options?.align ? options.align : "left";

  const textSize = printer.printTextExt(text, x, y, "unlimited", {
    align: align || "left",
  });
  const lineStart = align !== "right" ? x + textSize.width : x;
  printer.doc.line(
    lineStart + (space || 5),
    y + (offset || 0),
    end,
    y + (offset || 0)
  );

  return textSize;
}
